import React from 'react';
import { Skeleton } from '@mui/material';

const MapSectionSkeleton = () => (
    <Skeleton variant="rectangular" width="100%" height={800} />
);
export { MapSectionSkeleton };
